import { DefaultLayout } from "@westpierstudio/luma/layout";
import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";
import { Sprite } from "pixi.js";

export class KSGLogo extends View {

    protected logo: Sprite;
    layout: DefaultLayout;

    /**
     *
     * @param services
     * @param layout Is the layout service this instance of the component is rendering in.
     */
    constructor(protected override readonly services: GameServices, layout: DefaultLayout) {
        super(services);
        const {resources, factory} = services;

        this.layout = layout;

        const defaultSpec = resources.getSpec(`ksg-logo`).ksgLogo;
        this.logo = factory.createSprite(defaultSpec, this);
    }

    resize() {

        if (this.parent && this.parent.parent) {
            this.parent.parent.updateTransform();
        }

        const {resources, factory} = this.services;

        if (this.layout.landscape) {
            const landscapeSpec = resources.getSpec(`ksg-logo`).ksgLogo;
            factory.applySpec(this.logo, landscapeSpec);
        } else {
            const defaultBucket = this.services.loadscreenLayout.calculateLayout();
            const actualBucket = this.layout.calculateLayout();

            factory.applySpec(this.logo, resources.getSpec(`ksg-logo`).ksgLogo.portrait);
            this.worldTransform.applyInverse(this.logo.position, this.logo.position);

            // reference games portrait scale (ts-slot-ksg-lucky-larrys-lobstermania/v1.0.192-debug)
            const referenceBucketScale = 1.38;

            let scale = 1;
            scale /= actualBucket.stageScale; // undo current bucket scale
            scale *= defaultBucket.stageScale; // apply default (unpadded) bucket scale
            scale *= referenceBucketScale; // apply reference game portrait scale
            this.logo.scale.set(scale);
        }
    }
}